import type { ComponentPropsWithRef, ReactNode } from 'react';

import { clsx } from '~/styles/utils';

import { Text } from '../Text/Text';
import { contentStyle, labelRowStyle, labelStyle, labelVariantStyles, rootStyle, rootVariantStyles } from './InfoBlock.css';

type Props = ComponentPropsWithRef<'div'> & {
  action?: ReactNode;
  children: ReactNode;
  label: string;
  variant?: 'section' | 'caps';
};

export const InfoBlock = ({ action, children, label, variant = 'section', ...delegated }: Props) => {
  return (
    <div {...delegated} className={clsx(rootStyle, rootVariantStyles[variant], delegated.className)}>
      <div className={labelRowStyle}>
        <Text className={clsx(labelStyle, labelVariantStyles[variant])}>{label}</Text>
        <div className={contentStyle}>{children}</div>
      </div>

      {action}
    </div>
  );
};
